module.exports = __webpack_public_path__ + "static/assets/6f8099642bca2cac1893f944dd47d330.png";